import Button from "./Button";

const Modal = ({
	modal,
	icon,
	children,
	name,
	handleClose,
	submit,
	loading,
	width,
	footer,
	disabledSubmit = false,
}) => {
	return modal.show ? (
		<>
			{/* OVERLAY (WINDOW SCROLL) */}
			<div className="fixed inset-0 z-[60] overflow-y-auto">
				{/* MODAL WRAPPER */}
				<div className="relative min-h-screen flex justify-center items-center pt-[40px] pb-[100px]">
					<div className={`relative ${width ? width : "w-[600px]"} mx-auto max-w-3xl`}>
						<div className="border border-4 border-black rounded-xl flex flex-col w-full bg-white">
							{/* HEADER */}
							<div className="flex items-start justify-between pt-5 px-10 mb-10">
								<div className="flex items-center">
									<img src={icon} alt="" className="w-[40px] h-[40px]" />
									<h3 className="text-3xl font-semibold ms-5 capitalize">{name}</h3>
								</div>
								<button
									className="p-1 ml-auto bg-black text-white hover:bg-white hover:text-black hover:border border-black rounded-xl text-3xl font-semibold shadow-[0px_0px_4px_3px_#00000040]"
									onClick={handleClose}
								>
									<span className="h-7 w-7 block">×</span>
								</button>
							</div>

							{/* BODY */}
							<div className="relative px-10">{children}</div>

							{/* FOOTER */}
							<div className="relative py-5 px-10">
								{footer ? (
									footer
								) : (
									<Button
										type="submit"
										onClick={submit}
										disabled={loading || disabledSubmit}
										className="py-5 capitalize"
									>
										{modal.type} Data
									</Button>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* BACKDROP */}
			<div className="fixed inset-0 z-40 bg-black opacity-25"></div>
		</>
	) : null;
};

export default Modal;
